<template>
  <v-container id="view-login">
    <v-layout justify-center wrap>
      <v-flex xs12 md8>        
        <base_Login @onClick="event_login"></base_Login>

        <!-- Ventana de mensajes iniciales -->        
        <component
          :is="componenteDinamico"
          :mensajes="mensajes"
          @continuar="componenteDinamico= null"
          @rechazar="rechazar">
        </component>
        
      </v-flex>
    </v-layout>
  </v-container>
</template>



<script>

  import plugs from "@/common/general_plugs";
  import msgView from "@/components/msgView";
  import apdsContrato from "@/components/apdsContrato";
  import { mapGetters } from 'vuex';
  const base_Login = () => plugs.groute("base_Login.vue", "base");

  export default {
    components: { base_Login, msgView, apdsContrato },
    data() {
      return {
        modal: false,
        componenteDinamico: null,
        mensajes:{},
        ruta:'',

        // módulos a mostrar al iniciar sesión
        modulos: {          
          mensajes:{ fn:'msgIniciales' },
          contrato:{ fn:'firmaContrato' }
        },
                
      };
    },

    created() {  
      if (this.isLogued) {
        this.$router.push({ path: '/' });
        this.$store.commit("set_activeMenu", []);
      }
    },


    methods: {

      // acciones de los botones del login
      event_login(accion, txt_user, txt_pass) {
        // compruebo si el navegador soporta Local Storage
        if (typeof Storage === "undefined") {
          this.$root.$alert.open("Local Storage no soportado", "error");
          return;
        }

        if (accion== 'user') {
          this.validate_usuario(txt_user);    
          return;
        }

        this.validate_password(txt_pass);
      },


      // compruebo si el usuario existe
      async validate_usuario(txt_user){

        // chequeo usuario en la Api
        let args = {
          accion: "check_username",
          tipo: "login",
          api: "login",          
          fn_args: { 
            user: txt_user, 
            app: this.$store.state.G.APP          
          }
        };
       
        let apiResult = await this.$store.dispatch("ajaxRequest", { args: args });
       
        // el usuario es correcto
        if (apiResult.continue) {
          // guardo el token de usuario
          sessionStorage.setItem("username", apiResult.token_user);
          return;
        }

        // elimino el token de usuario
        sessionStorage.removeItem("username");
      },


      // termino el login si las validaciones de usuario y contraseña son correctas
      async validate_password(txt_pass) {
       
        // valido usuario y contraseña
        let args = {
          tipo: "login",
          api: "login",
          accion: "check_password",
          fn_args: {
            user: sessionStorage.getItem("username"), // token
            pass: txt_pass
          }
        };
        
        let apiResult = await this.$store.dispatch("ajaxRequest", { args: args });
        
        // usuario y contraseña válidos
        if (apiResult.continue) {
          sessionStorage.removeItem("username"); // elimino el token de usuario        
          await this.$store.commit("set_authSuccess", apiResult.token);

          // cargo datos iniciales
          await this.cargaInicial();

          // muestro módulos iniciales
          for (let modulo in this.modulos) {
            if (!this.isLogued) break;
            await this[this.modulos[modulo].fn](); 
          }
          
          // compruebo si el usuario está logueado
          if (this.isLogued) {
            this.$router.push({ path: '/' });

          }else {
            location.reload();
          }
          
          return;
        }

        this.$store.commit("logout");
        this.$root.$alert.open('Usuario o contraseña invalidos', 'error');
      },


      async cargaInicial() {
        let apiResult= await this.$store.dispatch("ini/load_dataIni");
        
        if (apiResult.sql.error) {
          this.$root.$alert.open(apiResult.sql.msg, 'error');
          this.$store.commit("logout");
        }      
      },  

      

      // muestro componente Mensajes Particulares / Generales
      msgIniciales() {        
        return new Promise(resolve=> {
          let gen= this.$store.state['G'].MSGGEN;
          let part= this.$store.state['G'].USUDAT.msg;

          if (!gen && !part) {            
            resolve();
            return;
          }
         
          // muestro componente Mensajes Particulares / Generales
          this.componenteDinamico= 'msgView';
          this.mensajes = { gen, part };

          // watch para detectar cuando se cierra el componente
          // y resolver la función asíncrona
          this.$watch("componenteDinamico", {
            immediate: true,
            handler() {
              if (!this.componenteDinamico) resolve();              
            }
          });

        })
        
      },


      // muestro componente Firma de Contrato
      firmaContrato() {

        return new Promise(resolve=> {
          //sino marcado para la firma
          if (this.$store.state.G.FIRMACTT!='1') {
            resolve();
            return;
          }

          this.componenteDinamico= 'apdsContrato';

          // watch para detectar cuando se cierra el componente
          // y resolver la función asíncrona
          this.$watch("componenteDinamico", {
            immediate: true,
            handler() {
              if (!this.componenteDinamico) resolve();              
            }
          });        

        });

      },


      rechazar() {
        this.componenteDinamico= null;
        this.$store.commit("logout");
      },

    },


    computed: {
      ...mapGetters(['isLogued'])
    }

  };
</script>
